module.exports = __webpack_public_path__ + "static/media/Left-back.76d1cd0e.svg";